var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"monitorContainer"},[_c('video',{attrs:{"id":"videoElement","muted":""},domProps:{"muted":true}})])])}
var staticRenderFns = []

export { render, staticRenderFns }